import { index, integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

import { baseColumns } from './baseColumns';

// ============================================
// Post Engagements
// ============================================

export const postEngagements = sqliteTable(
  'post_engagements',
  {
    ...baseColumns,
    postId: text('post_id').notNull(),
    viewedAt: integer('viewed_at').notNull(), // Unix timestamp (ms)
    duration: integer('duration').notNull()
  },
  (t) => [
    index('idx_post_engagements_post_id').on(t.postId),
    index('idx_post_engagements_created_at').on(t.createdAt)
  ]
);
